/**
 * True when the given browsing context is nested inside another one
 * (iframe, frame, object).
 *
 * A nested context is not a user session. When an application boots inside a
 * frame, tracking boots with it, but nobody navigated: a page view from there
 * describes no navigation and is pure volume. That holds whatever framed the
 * document, which is why the gate is a class invariant rather than a workaround
 * for one known embedder.
 *
 * `track()` and `identify()` are deliberately left alone — only the page view
 * is meaningless here.
 *
 * @param win the context to inspect — defaults to the current window, the
 * parameter exists so the cross-origin case is testable.
 */
export const isNestedBrowsingContext = (win: Window = window): boolean => {
	try {
		return win.self !== win.top;
	} catch {
		// Reading `top` threw, which only happens across a cross-origin
		// ancestor — the failure itself proves we are nested.
		return true;
	}
};
